import { render, staticRenderFns } from "./Texts_Pointer.vue?vue&type=template&id=73c84b56&"
import script from "./Texts_Pointer.vue?vue&type=script&lang=js&"
export * from "./Texts_Pointer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports